module.exports = __webpack_public_path__ + "static/media/emailIcon.9d8133f1.svg";